import React, { useEffect, useState } from "react";
import NewPostFormNew from "../components/form/NewPostFormNew";
import { useLocation } from "react-router-dom";
import { IonContent, IonPage, useIonRouter } from "@ionic/react";
import { formatHashtag } from "../utils/formatHashtag";
import { Helmet } from "react-helmet-async";

function NewPost() {
  const location = useLocation();
  const router = useIonRouter();

  const [content, setContent] = useState("");
  const [exam, setExam] = useState("");
  const [isVideoOnly, setIsVideoOnly] = useState(false); // Change to state

  useEffect(() => {
    if (location) {
      const query = new URLSearchParams(location.search);
      const _post = query.get("post");
      const _exam = query.get("exam");
      const _mode = query.get("mode"); // Get mode from URL
      if (_post) setContent(decodeURIComponent(_post));
      if (_exam) setExam(_exam);
      if (_mode === "video" || location.state?.onlyVideo) {
        setIsVideoOnly(true);
      }
    }
  }, [location]);

  const handleExamChange = (subject, chapterNumber) => {
    setExam(
      decodeURIComponent(
        `id=${subject
          .replace(/[^\w\s]/gi, "")
          .replace(/\s+/g, "")
          .toLowerCase()}${chapterNumber ? `&ch=${chapterNumber}` : ""}`,
      ),
    );

    setContent(formatHashtag(subject));
  };

  return (
    <>
      <Helmet>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      <IonPage>
        <IonContent
          className="post-content"
          fullscreen
          scrollEvents={true}
          forceOverscroll={false}
          scrollY={false}
          style={{ "--keyboard-offset": "0px" }}
        >
          <NewPostFormNew
            onlyVideo={isVideoOnly}
            prependValue={content}
            exam={exam}
            onComplete={() => router.push("/")}
            handleExamChange={handleExamChange}
          />
        </IonContent>
      </IonPage>
    </>
  );
}

export default NewPost;

